"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.keys.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _messageTemplate = require("@/types/messageTemplate");
var _messageTemplate2 = require("@/api/messageTemplate.api");
var _lodash = require("lodash");
var MessageTemplateModal = /*#__PURE__*/function (_Vue) {
  function MessageTemplateModal() {
    var _this;
    (0, _classCallCheck2.default)(this, MessageTemplateModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, MessageTemplateModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "rules", {});
    (0, _defineProperty2.default)(_this, "MessageTemplateTypeTrans", _messageTemplate.MessageTemplateTypeTrans);
    (0, _defineProperty2.default)(_this, "row", void 0);
    return _this;
  }
  (0, _inherits2.default)(MessageTemplateModal, _Vue);
  return (0, _createClass2.default)(MessageTemplateModal, [{
    key: "templateData",
    get: function get() {
      if (!this.form.templateJson || !!this.form.templateJson && !(0, _lodash.isArray)(JSON.parse(this.form.templateJson))) {
        return [];
      }
      return JSON.parse(this.form.templateJson);
    }
  }, {
    key: "dataSubmit",
    get: function get() {
      return {
        messageTemplate: (0, _objectSpread2.default)({}, this.form)
      };
    }
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.loading = true;
              _context.next = 4;
              return _messageTemplate2.messageTemplateApi.update(this.form.id, this.dataSubmit);
            case 4:
              this.visible = false;
              this.$notify({
                title: "Update message template",
                message: "Successfully",
                type: "success"
              });
              this.$emit("submit:ok");
            case 7:
              _context.prev = 7;
              this.loading = false;
              return _context.finish(7);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0,, 7, 10]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleUpdate",
    value: function () {
      var _handleUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(data) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.form = (0, _objectSpread2.default)({}, data);
              this.visible = true;
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleUpdate(_x) {
        return _handleUpdate.apply(this, arguments);
      }
      return handleUpdate;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
MessageTemplateModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {}
})], MessageTemplateModal);
var _default = exports.default = MessageTemplateModal;